import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import TeamBadge from 'scripts/components/common/TeamBadge/TeamBadge';

const TABLET_BREAKPOINT = 840;
const isTabletViewport = () => typeof window !== 'undefined' && window.innerWidth <= TABLET_BREAKPOINT;

/**
 * Renders the appropriate scorebox badge for the current viewport.
 *
 * Mounting one badge, rather than visually hiding a second SVG, prevents
 * duplicate SVG definition IDs from affecting the visible badge.
 *
 * @param {object} props - component props
 * @param {string} props.abbr - team abbreviation
 * @returns {object} React render
 */
export default function ScoreboxTeamBadge( { abbr } ) {
    const [ mobile, setMobile ] = useState( isTabletViewport );

    useEffect( () => {
        const updateViewport = () => setMobile( isTabletViewport() );

        window.addEventListener( 'resize', updateViewport );

        return () => window.removeEventListener( 'resize', updateViewport );
    }, [] );

    return (
        <TeamBadge
            abbr={ abbr }
            className="scorebox__team-badge"
            type={ mobile ? 'matchListDark' : 'matchListLight' } />
    );
}

ScoreboxTeamBadge.propTypes = {
    abbr: PropTypes.string
};
